import { createTheme, ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ColorConstants from '../../../../defaults/ColorConstants';
import FieldNames from '../../../../defaults/FieldNames.json';
import ErrorService from '../../../../services/ErrorService';
import FeatureService from '../../../../services/FeatureService';
import { ListboxComponent } from '../../../../utils/ListHelper';

const useStyles = makeStyles(() => ({
  formControl: {
    margin: 15,
    minWidth: 120,
    width: '90%'
  },
  select: {
    color: ColorConstants.GrayAlien,
    backgroundColor: ColorConstants.WhiteAlien,
    '&.MuiSelect-icon': {
      color: ColorConstants.GrayAlien,
    }
  },
  inputLabel: {
  },
}));

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          //border on focus
          borderColor: ColorConstants.BlueAlien,
          border: '2px solid'
        },
      },
    },
    MuiSelect: {
      icon: {
        color: ColorConstants.GrayAlien
      },
      root: {
        //padding: 16
      }
    },
    MuiInputLabel: {
      root: {
        // fontSize: 14
      }
    }
  },
});

export default function AutoCompleteFilter({ filter, setValue, value, codedValues, id,
  rootServiceUrl, config, nifcToken, userInfo, cachedValues, setCachedValues
 }) {
  const [dropdownValues, setDropdownValues] = useState(filter.domain.codedValues === null ? [] : filter.domain.codedValues);
  //const [dropdownValue, setDropdownValue] = useState('');
  const [isLoading,setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if(codedValues){
      setDropdownValues(codedValues);
    }
  }, [codedValues])

  const loadData = () => {
    if(!codedValues && filter?.name === FieldNames.filters.names)
    {
      setIsLoading(true);
      // Replace this with a proper application cache when we're able to
      if(cachedValues?.length > 0)
      {
        setDropdownValues(cachedValues);
      }
      else
      {
        FeatureService.getAllNames().then(response => {
          if(response?.length > 0){
            // Cache response properly here when we're able to do so
            setCachedValues(response);
            setDropdownValues(response);
          }
        }).catch(error => {
          ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
        }).finally(() => {
          setIsLoading(false);
        });
      }
    }
  }

  const handleChange = (event, newValue) => {
    dispatch(setValue(newValue));
  };

  const classes = useStyles();

  return (
    <div>
      <ThemeProvider theme={theme}>
        <FormControl variant="outlined" className={classes.formControl}>
          <Autocomplete
            multiple={true}
            value={value ? value : []}
            id={id}
            options={dropdownValues}
            getOptionLabel={(option) =>
              option && option.name ? option.name : option
            }
            onChange={(event, newValueList) => {
              handleChange(event, newValueList);
            }}
            loading={isLoading}
            onOpen={() => {
              loadData();
            }}
            disablePortal
            sx={{width: 300}}
            renderInput={(params) => <TextField {...params} label={filter ? (filter.name ? filter.name : filter) : ""} />}
            renderOption={(props, option, state) => [
              props,
              option,
              state?.index,
            ]}
            disableListWrap
            slotProps={{ 
              listbox: {
                component: ListboxComponent
              }
            }}
          />
        </FormControl>
      </ThemeProvider>
    </div>
  );
}